import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { ProductLookup } from '../types/api';
import type { Product } from '../types/product';
import { ProductApi, type ProductApiContract } from './product.api';

export interface ProductsApiContract {
  product(lookup: ProductLookup): ProductApiContract;
  search(query: string): Promise<Product[]>;
}

declare module '@sparklayer-io/spark-dash-core/context/page-context' {
  interface Apis {
    products: ProductsApiContract;
  }
}

/**
 * A service to interact with products via the SparkLayer API.
 */
export class ProductsApi extends ApiService implements ProductsApiContract {
  public product(lookup: ProductLookup): ProductApiContract {
    return new ProductApi(this.api, lookup);
  }

  public search(query: string): Promise<Product[]> {
    const encQuery: string = encodeURIComponent(query);
    return this.api.proxy({
      method: 'GET',
      path: '/v2/search-products/{query}',
      params: { query: encQuery },
    });
  }
}
